/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Planner_CopyInputs */

const en_control_planner_copy = /** @type {(inputs: Control_Planner_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy share link`)
};

const zh_control_planner_copy = /** @type {(inputs: Control_Planner_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制分享链接`)
};

/**
* | output |
* | --- |
* | "Copy share link" |
*
* @param {Control_Planner_CopyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_planner_copy = /** @type {((inputs?: Control_Planner_CopyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Planner_CopyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_planner_copy(inputs)
	return zh_control_planner_copy(inputs)
});
export { control_planner_copy as "control.planner.copy" }